import { useIntl } from 'react-intl';

export const useIsTranslationExists = (): (({ id }: { id: string }) => boolean) => {
  const intl = useIntl();
  return ({ id }: { id: string }) => !!intl.messages[id];
};
